/**
 * KbAddDrawer – lightweight wrapper around KnowledgeBaseEntryDrawer pre-filled
 * with content from a chat message or task artifact, to be saved to a KB.
 */
import React from 'react';
import KnowledgeBaseEntryDrawer from './KnowledgeBaseEntryDrawer';

export interface KbAddDraft {
  suggestedTitle: string;
  contentMarkdown: string;
  summary?: string;
  sourceModule?: string;
  sourceId?: string;
  tags?: string[];
}

interface Props {
  open: boolean;
  onClose: () => void;
  draft: KbAddDraft;
  userId?: string;
  onSaved?: (result: { knowledgeBaseId: string; knowledgeBaseName?: string }) => void;
}

const KbAddDrawer: React.FC<Props> = ({ open, onClose, draft, userId = '', onSaved }) => (
  <KnowledgeBaseEntryDrawer
    open={open}
    onClose={onClose}
    userId={userId}
    draft={{
      suggestedTitle: draft.suggestedTitle,
      contentMarkdown: draft.contentMarkdown,
      summary: draft.summary ?? draft.contentMarkdown.slice(0, 400),
      sourceModule: draft.sourceModule ?? 'chat_workspace',
      sourceId: draft.sourceId,
      tags: draft.tags ?? ['chat-result'],
    }}
    onSaved={onSaved}
  />
);

export default KbAddDrawer;
